import { DEV } from 'solid-js'
import { safeParse } from 'valibot'
import { ArmyPaintCollectionSchema, type ArmyPaintCollection } from '../../../lib/core/ArmyPainter/ArmyPaintCollection.type'
import { getJsonOrNullFromLocalStorage } from '../../../lib/localStorage'
import { Nullable } from '../../../typescript'

export const ARMY_PAINT_VALUE_LS_KEY = 'ap0'

export default function getArmyPaintCollectionValueFromLocalStorage(): Nullable<ArmyPaintCollection> {
  const value = getJsonOrNullFromLocalStorage(ARMY_PAINT_VALUE_LS_KEY)
  const result = safeParse(ArmyPaintCollectionSchema, value)
  if (result.success) {
    return result.output
  }
  if (DEV) {
    if (value) {
      console.warn(result, value)
    }
  }
}
